import { useState } from "react";
import axios, { AxiosError } from "axios";
import { managementService } from "../../../../configs/constants";
import { message } from "antd";

type SendDocumentPayload = {
  documentName: "TENANCY_CONTRACT" | string;
  leaseId: string;
  recipientEmail: string;
  recipientName: string;
  sendTo: "landlord" | "tenant";
};

type UseSendDocumentResult = {
  sendDocument: (payload: SendDocumentPayload) => Promise<void>;
  loading: boolean;
  error: string | null;
  success: boolean;
};

export const useSendDocumentForSignature = (onCancel): UseSendDocumentResult => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const sendDocument = async (payload: SendDocumentPayload) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await axios.post(`${managementService}/leasing/docusign/sendDocumentForSignature`, payload);
      message.success("Document sent for signature successfully");
      onCancel();
      setSuccess(true);
    } catch (err) {
      const axiosError = err as AxiosError<any>;
      message.error(axiosError.response?.data?.error || axiosError.message || "Failed to send document for signature");
    } finally {
      setLoading(false);
    }
  };

  return {
    sendDocument,
    loading,
    error,
    success,
  };
};
